exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-fathersday-rule .main[data-v-ed15333a] {\n  background: #CCE0FC;\n  border-radius: 3px;\n  padding: 15px;\n}\n.page-fathersday-rule .main .textcontent[data-v-ed15333a] {\n  background-color: #fff;\n  border-radius: 3px;\n  border: 0.5px solid #003589;\n}\n.page-fathersday-rule .main h3[data-v-ed15333a] {\n  padding: 10px 0;\n  text-align: center;\n  border-bottom: 5px solid #cce0fc;\n  color: #454545;\n}\n.page-fathersday-rule .main .content[data-v-ed15333a] {\n  padding: 20px;\n}\n", ""]);

// exports
